import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';

const JOURNEY_DATA = DATA.journey;

const Journey = () => {
    return (
        <section className="journey-block container">
            <p className="title">{JOURNEY_DATA.title}</p>
            <div className="content">
                {JOURNEY_DATA.content.map((item, index) => {
                    return (
                        <div key={index} className='item'>
                            {item.level === 2 && <img alt='' src='/images/your-are-here.png' className="image"/>}
                            <div className="level-wrapper" style={{backgroundImage: `url(/images/journey-level-${index}.png)`}}>
                                <p>Level {item.level}</p>
                            </div>
                            <div className="title-wrapper" style={item.level === 3 ? {borderLeft: "1px dashed #000000"} : {}}>
                                {item.title.map((text, index) => {
                                    return (
                                        <div className="title-wrapper__title">
                                            {item.level === 3 && <div className="line" />}
                                            <p key={`title-${index}`}>{text}</p>
                                        </div>
                                    )
                                })}
                            </div>
                            <p className="desc">{item.desc}</p>
                            {item.note && 
                                <div className="note-wrapper">
                                    <img alt='' src={item.note.image}/>
                                    <p style={{color: item.level === 2 ? '#3BDBD9' : '#00A899'}}>{item.note.text}</p>
                                </div>
                            }
                        </div>
                    )
                })}
            </div>
        </section>
    )
}

export default Journey